export default __webpack_public_path__ + "static/media/peter_blamey.8b1d877a.jpg";